import { useLocation } from '@tanstack/react-router'
import { URL_PATH_DRILLDOWN_EXPLORATION_VIEWER } from 'features/drilldown'
import React from 'react'

import { Homebar } from './Homebar'
import { SelectedTab } from './types'
import { useNavbarConfig } from './useNavbarConfig'
import { useNavbarData } from './useNavbarData'

export const getSelectedTab = (pathname: string): SelectedTab | undefined => {
  if (pathname.includes('/home')) return SelectedTab.Home
  if (pathname.includes('/assets')) return SelectedTab.Assets
  if (pathname.includes('/ships')) return SelectedTab.Ships
  if (pathname.includes('/inspections')) return SelectedTab.Inspections
  if (pathname.includes('/inspection-dashboard')) return SelectedTab.Inbox
  if (pathname.includes('publisher')) return SelectedTab.Publisher
  if (pathname.includes('/health-plans')) return SelectedTab.HealthPlans
  if (pathname.includes('/budgeting')) return SelectedTab.Budgeting
  if (pathname.includes('/scheduling')) return SelectedTab.InspectionScheduling
  if (pathname.includes('/availability-planning'))
    return SelectedTab.AvailabilityPlanning
  if (pathname.includes(`/overview`)) return SelectedTab.Overview
  if (pathname.includes('/cases')) return SelectedTab.Cases
  if (pathname.includes(URL_PATH_DRILLDOWN_EXPLORATION_VIEWER))
    return SelectedTab.Exploration
  if (pathname.includes('/explorer')) return SelectedTab.Explorer
  if (pathname.includes('/prism')) return SelectedTab.Prism
  if (pathname.includes('/parts')) return SelectedTab.PartsThread
  if (pathname.includes('/jobs')) return SelectedTab.JobsOverview
  if (pathname.includes('/walkdowns')) return SelectedTab.Walkdowns
  if (pathname.includes('/reporting')) return SelectedTab.Reporting
  if (pathname.includes('/inventory')) return SelectedTab.InventoryManagement
  if (pathname.includes('/maximo')) return SelectedTab.Maximo
  if (pathname.includes('/system-lens')) return SelectedTab.SystemLens
  if (pathname.includes('/point-cloud')) return SelectedTab.PointCloud
  if (pathname.includes('/process-flows'))
    return SelectedTab.ProcessFlowDiagrams
  if (pathname.includes('/value-stories')) return SelectedTab.ValueStories
  if (pathname.includes('/process-data')) return SelectedTab.ProcessData
  if (pathname.includes('/walkthrough')) return SelectedTab.Walkthrough
  if (pathname.includes('/anomaly-detection'))
    return SelectedTab.AnomalyDetection
  if (pathname.includes('/documents')) return SelectedTab.Documents
  if (pathname.includes('/libra')) return SelectedTab.Libra
  if (pathname.includes('/nii-dashboard')) return SelectedTab.NiiDashboard
  if (pathname.includes('/production-dashboard'))
    return SelectedTab.ProductionDashboard
  if (pathname.includes('/virtual-reports')) return SelectedTab.VirtualReports
  if (pathname.includes('/notifications')) return SelectedTab.Notifications
  if (pathname.includes('/site-context-monitoring'))
    return SelectedTab.SiteContextMonitoring
  if (pathname.includes('/dossiers')) return SelectedTab.Claims
  if (pathname.includes('/weldmap')) return SelectedTab.WeldMap
  if (pathname.includes('/logbook')) return SelectedTab.Logbook
  if (pathname.includes('/alerts')) return SelectedTab.Alerts
}

export const Navbar: React.FC<{
  orgOrSiteID?: string
  defaultClosed?: boolean
  hideSiteSelector?: boolean
  hideSearchBar?: boolean
  hideMenuButton?: boolean
}> = ({
  orgOrSiteID,
  hideSiteSelector = false,
  hideSearchBar = false,
  hideMenuButton = false,
}) => {
  const location = useLocation()

  const {
    site,
    sites,
    sitesForOrg,
    organization,
    organizations,
    isLoading,
    hasEverLoaded,
  } = useNavbarData(orgOrSiteID)

  const { showHomebarSearch } = useNavbarConfig({
    orgId: organization?.id ?? '',
    siteId: site?.id,
  })

  const shouldHideSiteSelector = hideSiteSelector
  const shouldHideSearchBar = hideSearchBar || !showHomebarSearch

  const selectedTab = getSelectedTab(location.pathname + location.search)

  return (
    <Homebar
      hideSiteSelector={shouldHideSiteSelector}
      hideSearchBar={shouldHideSearchBar}
      hideMenuButton={hideMenuButton}
      selectedOrganization={organization}
      organizations={organizations}
      selectedSite={site}
      sites={sites}
      sitesForOrg={sitesForOrg}
      isLoading={isLoading}
      hasEverLoaded={hasEverLoaded}
      selectedTab={selectedTab}
    />
  )
}
